import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../api/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import AuthShell from "../components/AuthShell";

const Register = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      await API.post("/users/auth/register", { username, email, password });
      setSuccess("Account created! Redirecting to login...");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed. Please try again.");
    }
  };

  return (
    <AuthShell title="Create account" subtitle="Sign up to get started with Visa Portal">
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <form onSubmit={handleRegister}>
        <div className="mb-3">
          <label htmlFor="username" className="form-label fw-semibold">
            Username
          </label>
          <input
            type="text"
            id="username"
            className="form-control form-control-lg"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label fw-semibold">
            Email
          </label>
          <input
            type="email"
            id="email"
            className="form-control form-control-lg"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="mb-3 position-relative">
          <label htmlFor="password" className="form-label fw-semibold">
            Password
          </label>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            className="form-control form-control-lg"
            placeholder="Create a password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="btn btn-link position-absolute end-0 translate-middle-y p-0 me-3"
            style={{ top: "70%", color: "var(--vp-text-muted)" }}
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <button type="submit" className="btn btn-primary btn-lg w-100 rounded-pill">
          Sign up
        </button>
      </form>

      <p className="auth-footer-links">
        Already have an account? <Link to="/login">Login</Link>
      </p>
    </AuthShell>
  );
};

export default Register;
